/**
 * Pick black or white text for a given hex background (luminance).
 * Shared by topic tag pills across BasketContent, TopicSelectionModal, Connections.
 */
export const getContrastColor = (hexColor) => {
  if (!hexColor || typeof hexColor !== 'string') {
    return 'black';
  }

  try {
    const normalized = hexColor.startsWith('#') ? hexColor : `#${hexColor}`;
    const r = parseInt(normalized.slice(1, 3), 16);
    const g = parseInt(normalized.slice(3, 5), 16);
    const b = parseInt(normalized.slice(5, 7), 16);

    if ([r, g, b].some((channel) => Number.isNaN(channel))) {
      return 'black';
    }

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? 'black' : 'white';
  } catch (error) {
    console.warn('Invalid color format:', hexColor);
    return 'black';
  }
};
